/**
 * Generated from TextBoxLayout.fla
 */
export function TextBoxLayout(this: ITextBoxLayout) {
	const textBox = this.textBox;
	TextBoxLayout_textBox.call(this.textBox);
	textBox.x = 1024;
	textBox.y = 1536;
	if (textBox.onLayout) textBox.onLayout();
	return this;
}
export function TextBoxLayout_textBox(this: ITextBoxLayout_textBox) {
	const textBoxBg = this.textBoxBg;
	TextBoxLayout_textBoxBg.call(this.textBoxBg);
	textBoxBg.x = -704.5;
	textBoxBg.y = -237;
	textBoxBg.width = 1409.00;
	textBoxBg.height = 237.00;
	if (textBoxBg.onLayout) textBoxBg.onLayout();
	const textBoxOutline = this.textBoxOutline;
	TextBoxLayout_textBoxOutline.call(this.textBoxOutline);
	textBoxOutline.x = -710;
	textBoxOutline.y = -245;
	textBoxOutline.width = 1420.00;
	textBoxOutline.height = 245.00;
	if (textBoxOutline.onLayout) textBoxOutline.onLayout();
	const bgMask = this.bgMask;
	bgMask.push(703.75,-236.65,696.50,14.35,-696.75,11.65,-705.40,-226.15);
	const textArea = this.textArea;
	textArea.x = -622.5;
	textArea.y = -208.65;
	textArea.textAreaWidth = 1263.85;
	textArea.textAreaHeight = 132.70;
	textArea.fontSize = 42;
	if (textArea.onLayout) textArea.onLayout();
	const speakerIcon = this.speakerIcon;
	TextBoxLayout_speakerIcon.call(this.speakerIcon);
	speakerIcon.x = -685.4;
	speakerIcon.y = -214.35;
	speakerIcon.width = 52.00;
	speakerIcon.height = 36.00;
	if (speakerIcon.onLayout) speakerIcon.onLayout();
	return this;
}
function TextBoxLayout_textBoxBg(this: ITextBoxLayout_textBoxBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("text-box-bg.png", 0.000, 0.000);
	return this;
}
function TextBoxLayout_textBoxOutline(this: ITextBoxLayout_textBoxOutline) {
	if (this.setLayoutTexture) this.setLayoutTexture("text-box-outline.png", 0.000, 0.000);
	return this;
}
function TextBoxLayout_bgMask(this: ITextBoxLayout_bgMask) {
	return this;
}
function TextBoxLayout_speakerIcon(this: ITextBoxLayout_speakerIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("speaker-icon.png", 0.000, 0.000);
	return this;
}
interface ITextBoxLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ITextBoxLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ITextBoxLayoutSprite extends ITextBoxLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ITextBoxLayoutText extends ITextBoxLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ITextBoxLayoutPolygon extends Array<number> {
}
interface ITextBoxLayout {
	readonly textBox: ITextBoxLayout_textBox;
}
interface ITextBoxLayout_textBox extends ITextBoxLayoutContainer {
	readonly textBoxBg: ITextBoxLayout_textBoxBg;
	readonly textBoxOutline: ITextBoxLayout_textBoxOutline;
	readonly bgMask: ITextBoxLayout_bgMask;
	readonly textArea: ITextBoxLayoutText;
	readonly speakerIcon: ITextBoxLayout_speakerIcon;
}
interface ITextBoxLayout_textBoxBg extends ITextBoxLayoutSprite {
}
interface ITextBoxLayout_textBoxOutline extends ITextBoxLayoutSprite {
}
interface ITextBoxLayout_bgMask extends ITextBoxLayoutPolygon {
}
interface ITextBoxLayout_speakerIcon extends ITextBoxLayoutSprite {
}
